import RegisterForm from "@/components/RegisterForm";

export default function RegisterSeller() {
  return <RegisterForm role="seller" />;
}
